import { Validators } from "@angular/forms";
import { BasespaceFormControl, BasespaceFormProperties } from "../bs-app-launch-form-control";
import { BsAppLaunchSectionBreakControlComponent } from "./bs-app-launch-section-break-control.component";


export interface SectionBreakFormControlProperties extends BasespaceFormProperties<BsAppLaunchSectionBreakControlComponent> {
    title: string;
}

// Reference docs: https://dagobah-developer.cloud-test.illumina.com/docs/content/documentation/apptools/formbuilder-overview#SectionBreak
// Reference class: src/Cloud.FormBuilder/Models/SectionBreak.cs
export class SectionBreakFormControl extends BasespaceFormControl<BsAppLaunchSectionBreakControlComponent> implements SectionBreakFormControlProperties {
    title: string;

    constructor(
        data: SectionBreakFormControlProperties
    ) {
        const { id, componentReference, label, helpText, value, required, requiredMessage, title, tabularFieldSetStyling, formControlType } = data;
        super({ id, componentReference, label, helpText, value, required, requiredMessage, tabularFieldSetStyling, formControlType });

        this.title = title;
        this.label = this.title ? this.title : this.label;
        this.size = '100%';
    }

    getRequestEntries(): any[][] {
        return [];
    }
    
}